import React from "react";
import "./Skeleton.css";

const CategorySkeleton = ({ count, widths = [] }) => {
  return (
    <div className="skeleton-categories" style={{ minHeight: "230px" }}>
      {[...Array(count)].map((_, index) => (
        <div
          className="skeleton-category-item"
          key={index}
          style={{ width: widths[index] || "100px" }}
        ></div>
      ))}
    </div>
  );
};

export default CategorySkeleton;
